import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-auth0-test',
  templateUrl: './auth0-test.component.html',
  styleUrls: ['./auth0-test.component.scss']
})
export class Auth0TestComponent {

  constructor(
    private auth: AuthService,
    @Inject(DOCUMENT) public document: Document
  ) { }

  onLogin() {
    this.auth.loginWithRedirect({
      appState: { target: '/home' },
      authorizationParams: {
      prompt: 'login' 
    }
    });
  }

  onLogout() {
    this.auth.logout({ 
      logoutParams: { 
        returnTo: this.document.location.origin
      }
    });
  }

}
